"use strict";

exports.__esModule = true;
exports.default = void 0;

var roundTo = function roundTo(step, allowNegative) {
  if (allowNegative === void 0) {
    allowNegative = false;
  }

  return function (num) {
    if (Number(step) === 0.5) {
      return Math.round(num * 2) / 2;
    } // round numbers to decimal places in step so we don't get crazy JS Number values


    var stepAsString = step.toString();
    var precision = stepAsString.includes('.') ? step.toString().split('.')[1].length : 0;
    var rounded = parseFloat((Math.round(+num / step) * step || 0).toFixed(precision));

    if (!allowNegative) {
      return Math.abs(rounded);
    }

    return rounded;
  };
};

var _default = roundTo;
exports.default = _default;